import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';

import { routes } from './app.routes';
import { sessionExpiredInterceptor } from './core/auth/session-expired.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'top' })),
    // Nessun interceptor di autenticazione: l'API è same-origin e la sessione viaggia
    // nel cookie HttpOnly, quindi non c'è alcun header da iniettare.
    provideHttpClient(withFetch(), withInterceptors([sessionExpiredInterceptor])),
  ],
};
